<template>
    <div id="statement_acceptance">
        <div class="acceptance_checkbox">
            <input type="checkbox" name="acceptance" id="acceptance" v-model="checked">
            <label for="acceptance"><strong>{{$t("components.AcceptTerms.accept[0]")}}</strong> {{$t("components.AcceptTerms.accept[1]")}}</label>
        </div>
        <div class="acceptance_button" :class="{disabled: !checked}" @click="next">
            <span>{{$t("components.AcceptTerms.accept[2]")}}</span>
            <div class="arrow-right"></div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        nextRoute : {
            type : String
        }
    },
    data: function(){
        return{
            checked: false,
            indexAux: '',
            newIndex: '',
        }
    },

    methods:{
        next(){
            this.checked = !this.checked
            this.$router.push(this.nextRoute)

            // if(this.checked){
                
            //     if(this.newIndex != 2){
            //         this.newIndex ++
            //         this.$emit('changeIndex')
                    
            //     }else{
                    
            //     }
            // }
        }
    }
}
</script>

<style lang="scss">
    #statement_acceptance{

        .acceptance_checkbox{
            display: flex;
            align-items: center;
            padding: 0 25px;
            height: 10vh;
            background-color: rgba($color: #02F0E4, $alpha: .3);

            label{
                color: #83037D;
                font-size: 15px;
                margin-left: 10px;
                
                strong{
                    font-weight: 700;
                }
            }
        }
        .acceptance_button{
            display: flex;
            align-items: center;
            text-align: center;
            height: 10vh;
            color: #000;
            font-weight: 700;
            text-decoration: none;
            background-color: #FFF581;

            span{
                font-size: 15px;
                letter-spacing: 6px;
                text-transform: uppercase;
                width: 90%
            }

            .arrow-right{
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #000;
                width: 10%
            }
        }

        .disabled{
            &:hover{
                cursor: not-allowed;
            }
            color: #BCC7CE;
            background-color: #F4F4F4;

        }
    }

    @media screen and (max-width: 400px){
        #statement_acceptance{
            .acceptance_checkbox{
                span{
                    font-size: 15px;
                }
            }
        }
    }
</style>